module.exports = __webpack_public_path__ + "img/12.58862a78.jpg";